// extracted by mini-css-extract-plugin
module.exports = {"informativePipe":"styles_informativePipe__3fGx0"};